import { makeStyles, Step, StepLabel, Stepper, Typography } from "@material-ui/core"
import React, { useState } from "react"
import { useCurrentStepperIndex } from "../../../stores/ui/ui.hooks"
import Logout from "../../logout/logout"
import Support from "../../support/support"
import useNeoWrapperModulesStyles from "./neo-wrapper-modules.styles"
import ToolTipPopUp from "./tool-tip-pop-up"
import { getPopUpMessage, popUpMessagesDoesNotHave } from "./tool-tip-pop-up-messages"
import { getCurrentTarget, getStepLabelFromStepDiv, stepLabelIsNot } from "./dom-checker"

export interface MenuOption {
  link: string,
  label: string
}

interface NeoWrapperModulesProps {
  menuOptions: MenuOption[],
  journeyId: string
}

const NeoWrapperModules: React.FC<NeoWrapperModulesProps> = ({ menuOptions, journeyId }) => {
  const classes = useNeoWrapperModulesStyles()
  const activeStepIndex = useCurrentStepperIndex()
  const useStyles = makeStyles(() => ({
    root: {
      paddingLeft: 16,
      paddingTop: 0,
      "& .MuiSvgIcon-root.MuiStepIcon-root.MuiStepIcon-completed": { color: "green" },
      "& .MuiStepIcon-text": { fill: "white" },
      "& .MuiStepIcon-active": { color: "#007DB8" },
      "& .MuiStepLabel-iconContainer": { marginTop: "0.1875rem" },
    }
  }))

  const c = useStyles()

  const getStepLabel = (currentStepIndex) => {
    let label = ""
    if (currentStepIndex === activeStepIndex) {
      label = "In Progress"
    } else if (currentStepIndex < activeStepIndex) {
      label = "Finished"
    } else {
      label = "Not Started"
    }
    return label
  }

  const [showPopUp, setShowPopUp] = useState(false)
  const [popUpMessage, setPopUpMessage] = useState(<></>)
  const [popUpPosition, setPopUpPosition] = useState<{top: number, left: number}>({ top: 0, left: 0})

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>): void | undefined => {
    const stepDiv = getCurrentTarget(event)

    if (stepLabelIsNot(stepDiv, "Not Started")) {
      setShowPopUp(false)
      return
    }

    const stepLabel = getStepLabelFromStepDiv(stepDiv)

    if (popUpMessagesDoesNotHave(stepLabel)) {
      setShowPopUp(false)
      return
    }

    const stepDivPosition = stepDiv.getBoundingClientRect()
    setPopUpPosition({top: stepDivPosition.top, left: stepDivPosition.left + 235})
    setPopUpMessage(getPopUpMessage(stepLabel))
    setShowPopUp(true)
  }

  const handleMouseLeave = (): void => {
    setShowPopUp(false)
  }

  return (
    <>
      <div className={classes.moduleList} >
        <Stepper activeStep={activeStepIndex} orientation="vertical" className={c.root}>
          {menuOptions.map((step, index) => (
            <Step key={step.label} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
              <StepLabel
                optional={
                  <Typography variant="caption">{getStepLabel(index)}</Typography>
                }
              >
                {step.label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <ToolTipPopUp show={showPopUp} message={popUpMessage} position={popUpPosition} />
      </div>
      <div className={classes.supportTooltipWrapper}>
        <div className={classes.supportTooltip}>
          We’d love to hear from you!
        </div>
      </div>
      <Support />
      <Logout />
    </>
  )
}

export default NeoWrapperModules